<div class="container-fluid">
  <p-panel>
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <h3>
        <span style="margin-left: 15px;"><fa-icon [icon]="['fas', 'books']"> </fa-icon> Training Record Documents </span>
      </h3>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="container-fluid eca-outline-border">
        <app-training-record-documents *ngIf="trainingRecordDocuments"
                                       showTableCaption="true" showHeaderText="false"
                                       [trainingRecordDocuments]="trainingRecordDocuments"
                                       (openDocument)="openTrainingRecordDocument($event)"
                                       (editDocument)="editTrainingRecordDocument($event)"
                                       (deleteDocument)="deleteTrainingRecordDocument($event)"
                                       (viewDocument)="viewTrainingRecordDocument($event)"
                                       (downloadDocument)="downloadTrainingRecordDocument($event)"
                                       [showAddDocumentButton]="false">
        </app-training-record-documents>
      </div>
    </ng-template>
  </p-panel>
</div>



